module.exports = __webpack_public_path__ + "img/logo-white-new.ae7c9285.png";